import styled from '@emotion/styled';

export const Article = styled.article`
  background: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.textDark};
  padding-bottom: 64px;
`;